import {lazy} from '@aboutyou/lazy-imports';

export const SubCategoriesSlider = lazy(() =>
  import('./SubCategoriesSlider.eager').then(mod => ({
    default: mod.SubCategoriesSlider,
  })),
);
